import React, { useMemo } from 'react';
import { useFieldStyles } from './hooks/useFieldStyles.js';
import { FieldWrap } from './FieldWrap.js';

const TextField = React.forwardRef(({ className = '', invalid = false, placeholder, type = 'text', theme = 'dark', ...rest }, ref) => {
    const styles = useFieldStyles({
        invalid,
        theme,
        ...rest,
    });
    const isTextarea = useMemo(() => type === 'textarea', [type]);
    const Component = useMemo(() => (isTextarea ? 'textarea' : 'input'), [isTextarea]);
    return (React.createElement(Component, { ref: ref, className: [styles, isTextarea ? 'h-28' : '', className].join(' '), placeholder: placeholder, ...(isTextarea ? {} : { type }), ...rest }));
});
const TextFieldControlled = ({ className, placeholder, type = 'text', theme, ...props }) => {
    return (React.createElement(FieldWrap, { ...{ theme, ...props } },
        React.createElement(TextField, { ...{
                className,
                placeholder,
                theme,
                type,
            } })));
};

export { TextField, TextFieldControlled };
//# sourceMappingURL=TextField.js.map
